import { asyncAction, syncAction } from '@/lib/action';
import type { User } from '@/domain/organizationUser/schemas';

export const signInAction = asyncAction('auth/SIGN_IN', (data) => ({ data }));
export const signInWithOrganizationAction = asyncAction('auth/SIGN_IN_WITH_ORGANIZATION');
export const signOutAction = asyncAction('auth/SIGN_OUT');

export const expiredAction = syncAction('auth/SET_EXPIRED');
export const setOrganizationIdAction = syncAction('auth/SET_ORGANIZATION_ID');
export const setOrgAdminAction = syncAction('auth/SET_ORG_ADMIN');
export const locationChangeAction = syncAction('env/LOCATION_CHANGE');
export const saveBackSearchUrlAction = syncAction<{
  query: unknown;
  routeParams?: Readonly<Record<string, string | undefined>>;
  params?: Readonly<Record<string, unknown>>;
}>('env/SAVE_BACK_SEARCH_URL');
export const savePersistedBackUrlAction = syncAction('env/SAVE_PERSISTED_BACK_URL');
export const setSagaDataLoadingAction = syncAction('env/SET_SAGA_DATA_LOADING');
export const addDataLoadingAction = syncAction('env/ADD_DATA_LOADING');
export const removeDataLoadingAction = syncAction('env/REMOVE_DATA_LOADING');

export const setNavigationAction = syncAction('env/SET_NAVIGATION');
export const updateNavigationAction = syncAction('env/UPDATE_NAVIGATION');
export const clearNavigationAction = syncAction('env/CLEAR_NAVIGATION');
export const documentChangeLinkedWidthAction = syncAction('env/CHANGE_LINKED_WIDTH');
export const paymentUpdateViewAction = syncAction('env/UPDATE_PAYMENT_VIEW');
export const setGoogleSearchTextAction = syncAction('env/SET_GOOGLE_SEARCH_TEXT');
export const setGooglePanelStatusAction = syncAction('env/SET_GOOGLE_PANEL_STATUS');
export const addAppStatusAction = syncAction('env/ADD_APP_STATUS');
export const removeAppStatusAction = syncAction('env/REMOVE_APP_STATUS');
export const getUserDataComplete = syncAction('env/GET_USER_DATA_COMPLETE');
export const updateUserFeaturesAction = asyncAction('env/UPDATE_USER_FEATURES');
export const updateSupplierAliasesAction = asyncAction('env/UPDATE_SUPPLIER_ALIASES');

export const updateWorkSpaceAction = syncAction('env/UPDATE_WORK_SPACE');
// cognito
export const cognitoAuthInitAction = syncAction('env/COGNITO_AUTH_INIT');
export const cognitoCleanAuthDataAction = syncAction('env/COGNITO_CLEAN_AUTH_DATA');

export const setErrorMessage = syncAction('env/SET_ERROR_MESSAGE');
export const connectionHealthAction = syncAction('env/CONNECTION_HEALTH');
export const requestAccessToModuleAction = asyncAction('env/REQUEST_ACCESS_TO_MODULE');
export const getPayModuleCompanyPermissionsAction = asyncAction('env/GET_PAY_MODULE_COMPANY_PERMISSIONS');

export const userProfileUpdatedAction = syncAction<User>('env/USER_PROFILE_UPDATED');
export const userPictureUpdatedAction = syncAction<string>('env/USER_PICTURE_UPDATED');
